import { SpreadsheetResultPayload, KColorResultPayload } from "./payload";
import { SpreadsheetSchema } from "./types";
import {KColorValue} from "../kcolor/kcolor-input";
import getKColorResultContextKey from "@utils/getKColorResultContextKey";

export async function storeRemoteSpreadsheetResults(
  results: any,
  payload: any,
  api: any
) {
  const cache_key: SpreadsheetSchema = {
    surveyId: payload.survey_id,
    outputId: payload.output_id,
    spreadsheetName: payload.spreadsheet_name,
    spreadsheetId: payload.spreadsheet_id,
  };
  const apiPayload = new SpreadsheetResultPayload(
    results,
    cache_key,
    "spreadsheet"
  );
  await api.post("/remote_calculation/store_results", apiPayload);
}

export async function getRemoteSpreadsheetResults(
  survey_id: number,
  api: any
): Promise<{ [key: number]: any }> {
  const schema: SpreadsheetSchema = {
    surveyId: survey_id,
  };

  const result = await api.post("/remote_calculation/get_results", {
    cache_key: schema,
    result_type: "spreadsheet",
  });
  if (result.length) {
    return result.reduce((acc, r: any) => {
      return {...acc, ...r.result}
    }, {});
  }
  return {};
}

export async function getRemoteKColorResults(
  surveyId: number,
  api: any
): Promise<{ [key: number]: any }> {
  const schema = {
    surveyId,
  };

  const result = await api.post("/remote_calculation/get_results", {
    cache_key: schema,
    result_type: "kcolor",
  }) as Array<any>;  // TODO add typing

  if (!result?.length)
    return {};

  return result.reduce((acc, item) => {
    // const key = item.cache_key.product + "____" + item.cache_key.color;
    const key = getKColorResultContextKey(
      item.cache_key.product, item.cache_key.color, item.cache_key.package
    );
    if (!!key)
      acc[key] = {...item.result, updated_at: item.created_at};
    return acc;
  }, {});
}
